// extracted by mini-css-extract-plugin
export default {"top":"VacanciesCreated_top__-+tit","box":"VacanciesCreated_box__qlgtS","addButton":"VacanciesCreated_addButton__-qOAk"};